export default {"src":"/_next/static/media/man-with-calc.ff86c71d.svg","height":234,"width":302,"blurWidth":0,"blurHeight":0};